import React, { useRef } from 'react';

import classNames from 'classnames';
import Slider from 'react-slick';

import cls from './Carousel.module.css';
import { useCarousel } from './useCarousel';

interface CarouselProps {
    classes?: string;
    images: string[];
    onShowPrevImage?: (currentIndex: number, currentUrl: string, e: React.SyntheticEvent) => void;
}

export const Carousel = ({ classes, images, onShowPrevImage }: CarouselProps) => {
    const sliderRef = useRef<Slider | null>(null);
    const { settings } = useCarousel(sliderRef);

    return (
        <div className={classNames(cls.carousel, classes)}>
            <Slider ref={sliderRef} {...settings}>
                {images.map((image, index) => (
                    <div
                        className={cls.carouselItem}
                        key={index}
                        onClick={(e) => onShowPrevImage(index, image, e)}
                    >
                        <img src={image} alt={`Slide ${index}`} />
                    </div>
                ))}
            </Slider>
        </div>
    );
};
